import React from "react";
import "./Executive.css";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

function Executive() {
  return (
    <div className="container frontboxExe">
      <div className="row">
        <div className="col-12">
          <div className="row ExeFrow">
            <div className="col-5 searchboxExe">
              <input type="text" placeholder="Comments" />
            </div>
            <div className="col-5 searchboxExe">
              {/* <input type="file" placeholder="Attach Photo" /> */}
              <Form.Control type="file" size="sm" />
            </div>
          </div>
        </div>
        <div className="col-12 searchboxExe">
          <input type="text" placeholder="QC Remarks" />
        </div>
        <div className="col-12 searchboxExe">
          <input type="text" placeholder="HSE Remarks" />
        </div>
        <div className="col-12 searchboxExe">
          <input type="text" placeholder="Manager Comments" />
        </div>
        <div className="col-12 searchboxExe">
          <input type="text" placeholder="Discription" />
        </div>
        <div className="col-12 Exebutton">
        <Button variant="danger" size="sm" >Activity Log</Button> &nbsp; &nbsp; &nbsp;
        <Button variant="success" size="sm" >Excute Activity</Button>&nbsp; &nbsp; &nbsp;
        </div>
      </div>
    </div>
  );
}

export default Executive;
